import baguetteBox from "baguettebox.js";

const GalleryInit = () => {
    const imageGallery = document.querySelector(".js-image-gallery");

    if (!imageGallery || !baguetteBox) return;

    baguetteBox.run(".js-image-gallery", {
        captions: false,
        bodyClass: 'no-scroll',
    });
};

export default GalleryInit;
